import '../../App.css';
import React, { useContext, useEffect, useState } from 'react';
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral';
import Footer from '../../components/footer/Footer';
import { IoIosWarning, IoIosCheckmarkCircle, IoIosCheckmark, IoIosClose } from "react-icons/io";
import { IoSettingsOutline, IoArrowBackOutline, IoInformationCircleOutline, IoRefreshOutline } from "react-icons/io5";
import { Drawer } from '@mui/material';
import { StyleContext } from '../../context/StyleContext';
import LoadingScreen from '../../components/LoadingScreen';
import { border } from '@mui/system';

const portfolioData = [
    {
        portfolio: 'Negócios',
        recursos: [
            { nome: 'Cadeia de Valor / Áreas', recurso: 'Area', importar: true, exportar: true },
            { nome: 'Capacidade de Negócios', recurso: 'CapacidadeNegocioDemanda', importar: true, exportar: true },
            { nome: 'Fornecedores', recurso: 'Fornecedor', importar: true, exportar: true },
        ],
    },
    {
        portfolio: 'Tecnologia',
        recursos: [
            { nome: 'Aplicações', recurso: 'Sistema', importar: true, exportar: true },
        ],
    },
    {
        portfolio: 'Serviços',
        recursos: [
            { nome: 'Serviço', recurso: 'Servico', importar: true, exportar: true },
            { nome: 'Grupo', recurso: 'Grupo', importar: true, exportar: true },
            { nome: 'Subgrupo', recurso: 'SubGrupo', importar: true, exportar: true },
            { nome: 'Item', recurso: 'Item', importar: true, exportar: true },
        ],
    },
];

const styles = {
    containerPrincipal: {
        padding: '0 20px 40px 20px',
        maxWidth: '100%',
    },
    tituloBloco: {
        padding: '30px 0 20px 0',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
    },
    tabelaWrapper: {
        border: '1px solid #e0e0e0',
        borderRadius: '4px',
        overflow: 'hidden',
        backgroundColor: '#fff',
        paddingBottom: "20px"
    },
    tabela: {
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: '13px',
    },
    thead: {
        backgroundColor: '#f5f5f5',
        borderBottom: '1px solid #e0e0e0',
    },
    thPortfolio: {
        padding: '10px 16px',
        textAlign: 'left',
        fontWeight: '600',
        fontSize: '11px',
        color: '#555',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        width: '220px',
    },
    thRecurso: {
        padding: '10px 16px',
        textAlign: 'left',
        fontWeight: '600',
        fontSize: '11px',
        color: '#555',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        width: '280px',
    },
    thOperacao: {
        padding: '10px 16px',
        textAlign: 'left',
        fontWeight: '600',
        fontSize: '11px',
        color: '#555',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
    },
    thAcao: {
        padding: '10px 16px',
        width: '50px',
    },
    trPortfolio: {
        borderTop: '1px solid #e0e0e0',
        backgroundColor: '#fafafa',
    },
    tdPortfolioNome: {
        padding: '10px 16px',
        fontWeight: '500',
        fontSize: '13px',
        color: '#333',
    },
    tdVazio: {
        padding: '10px 16px',
    },
    trRecurso: {
        borderTop: '1px solid #efefef',
        backgroundColor: '#fff',
    },
    tdRecursoVazio: {
        padding: '10px 16px',
    },
    tdRecursoNome: {
        padding: '10px 16px',
        color: '#444',
        fontSize: '13px',
    },
    tdOperacao: {
        padding: '10px 16px',
        fontSize: '13px',
    },
    tdAcao: {
        padding: '10px 16px',
        textAlign: 'center',
        verticalAlign: 'middle',
    },
    linkImportar: {
        color: '#2196F3',
        textDecoration: 'none',
        cursor: 'pointer',
        fontSize: '13px',
        border: 'none',
        backgroundColor: 'transparent'
    },
    linkExportar: {
        color: '#2196F3',
        textDecoration: 'none',
        cursor: 'pointer',
        fontSize: '13px',
    },
    separador: {
        color: '#bbb',
        margin: '0 6px',
        fontSize: '13px',
    },
    iconSettings: {
        color: '#aaa',
        fontSize: '16px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    btnVoltar: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: '#2196F3',
        fontSize: '13px',
        padding: '0',
    },
    thLog: {
        padding: '10px 16px',
        textAlign: 'left',
        fontWeight: '600',
        fontSize: '11px',
        color: '#555',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
    },
    thLogAcao: {
        padding: '10px 16px',
        textAlign: 'right',
        fontWeight: '600',
        fontSize: '11px',
        color: '#555',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
    },
    trLog: {
        borderTop: '1px solid #efefef',
        backgroundColor: '#fff',
    },
    tdLog: {
        padding: '10px 16px',
        color: '#444',
        fontSize: '13px',
    },
    tdLogAcao: {
        padding: '10px 16px',
        textAlign: 'right',
        fontSize: '13px',
    },
};

const situacaoConfig = {
    'Concluído': {
        bg: '#e8f5e9',
        color: '#2e7d32',
        dot: '#43a047',
        pulse: false,
        icon: IoIosCheckmark
    },
    'Falha': {
        bg: '#ffebee',
        color: '#c62828',
        dot: '#e53935',
        pulse: false,
        icon: IoIosClose
    },
    'Processando': {
        bg: '#fffde7',
        color: '#f57f17',
        dot: '#fbc02d',
        pulse: true,
        icon: null
    },
    'Pendente': {
        bg: '#fffde7',
        color: '#f57f17',
        dot: '#fbc02d',
        pulse: true,
        icon: null
    },
};

function BadgeSituacao({ situacao }) {
    const cfg = situacaoConfig[situacao] || { bg: '#f5f5f5', color: '#555', dot: '#999' };
    const Icon = cfg.icon;

    return (
        <span style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: cfg.pulse ? '6px' : 'none',
            backgroundColor: cfg.bg,
            color: cfg.color,
            fontSize: '11px',
            fontWeight: '600',
            padding: '3px 10px 3px 8px',
            borderRadius: '999px',
            letterSpacing: '0.03em',
            whiteSpace: 'nowrap',
        }}>
            {Icon ? (
                <Icon size={20} strokeWidth={2} style={{ flexShrink: 0 }} />
            ) : (
                <span style={{
                    width: '7px',
                    height: '7px',
                    borderRadius: '50%',
                    backgroundColor: cfg.dot,
                    flexShrink: 0,
                    display: 'inline-block',
                    animation: cfg.pulse ? 'pulse-dot 1.4s ease-in-out infinite' : 'none',
                }} />
            )}
            {situacao}
        </span>
    );
}

function SkeletonTabela() {
    return (
        <tbody>
            {Array.from({ length: 8 }).map((_, index) => (
                <tr key={index}>
                    <td style={{ padding: 16 }}>
                        <div className="skeleton-line" />
                    </td>
                    <td style={{ padding: 16 }}>
                        <div className="skeleton-line" />
                    </td>
                    <td style={{ padding: 16 }}>
                        <div className="skeleton-line" />
                    </td>
                    <td style={{ padding: 16 }}>
                        <div className="skeleton-pill" />
                    </td>
                    <td style={{ padding: 16 }}>
                        <div className="skeleton-button" />
                    </td>
                </tr>
            ))}
        </tbody>
    );
}

function formatarData(dataString) {
    if (!dataString) return '';
    // trunca os dígitos extras de fração de segundo (mantém só milissegundos)
    const dataSegura = dataString.replace(/(\.\d{3})\d+/, '$1');
    const data = new Date(dataSegura);
    if (isNaN(data.getTime())) return dataString; // fallback se não parsear

    return data.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });
}

const STATUS_EM_ANDAMENTO = ['Pendente', 'Processando'];

function TabelaLog({
    recurso,
    tipo,
    dados,
    loading,
    paginaAtual,
    totalPaginas,
    textoFiltro,
    temPendentes,
    onVoltar,
    onBuscar,
    onLimpar,
    onAtualizar,
    onIrParaPagina,
    onAcessarLog,
}) {
    const [localInput, setLocalInput] = useState(textoFiltro || "");

    const handleVoltarClick = () => {
        setLocalInput("");
        onVoltar();
    };

    return (
        <>
            <div style={styles.tituloBloco}>
                <button style={styles.btnVoltar} onClick={handleVoltarClick}>
                    <IoArrowBackOutline />
                    Voltar
                </button>
                <h3 style={{ margin: 0, fontSize: '15px', fontWeight: '500' }}>
                    Gestão de Dados – LOG de {tipo}: {recurso}
                </h3>
            </div>

            <div style={styles.tabelaWrapper}>
                <div
                    style={{
                        display: "flex",
                        gap: "10px",
                        padding: "15px 16px",
                        borderBottom: "1px solid #e0e0e0",
                        alignItems: "center",
                        justifyContent: "flex-end",
                    }}
                >
                    {temPendentes && (
                        <span
                            style={{
                                marginRight: "auto",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                                fontSize: "12px",
                                color: "#f57f17",
                            }}
                        >
                            <span style={{
                                width: '7px',
                                height: '7px',
                                borderRadius: '50%',
                                backgroundColor: '#fbc02d',
                                display: 'inline-block',
                                animation: 'pulse-dot 1.4s ease-in-out infinite',
                            }} />
                            Processamento em andamento — atualizando automaticamente...
                        </span>
                    )}

                    <input
                        type="text"
                        placeholder="Pesquisar..."
                        value={localInput}
                        onChange={(e) => setLocalInput(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                onBuscar(localInput.trim());
                            }
                        }}
                        style={{
                            width: "200px",
                            height: "32px",
                            padding: "0 10px",
                            border: "none",
                            borderBottom: "2px solid #ccc",
                            outline: "none",
                            fontSize: "13px",
                            background: "transparent",
                            borderRadius: "0",
                        }}
                        onFocus={(e) =>
                            (e.target.style.borderBottom = "2px solid #007bff")
                        }
                        onBlur={(e) => (e.target.style.borderBottom = "2px solid #ccc")}
                    />

                    <button
                        onClick={() => onBuscar(localInput.trim())}
                        style={{
                            padding: "6px 12px",
                            backgroundColor: "#007bff",
                            color: "#fff",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "12px",
                            fontWeight: "500",
                            whiteSpace: "nowrap",
                        }}
                    >
                        Buscar
                    </button>

                    <button
                        onClick={() => {
                            setLocalInput("");
                            onLimpar();
                        }}
                        style={{
                            padding: "6px 12px",
                            backgroundColor: "#f1f1f1",
                            color: "#333",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "12px",
                            fontWeight: "500",
                            whiteSpace: "nowrap",
                        }}
                    >
                        Limpar
                    </button>

                    <button
                        onClick={onAtualizar}
                        title="Atualizar situação dos arquivos"
                        style={{
                            padding: "6px 12px",
                            backgroundColor: "#f1f1f1",
                            color: "#333",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "12px",
                            fontWeight: "500",
                            whiteSpace: "nowrap",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "5px",
                        }}
                    >
                        <IoRefreshOutline />
                        Atualizar
                    </button>
                </div>

                <table style={styles.tabela}>
                    <thead style={styles.thead}>
                        <tr>
                            <th style={styles.thLog}>Usuário</th>
                            <th style={styles.thLog}>Data/Hora importação</th>
                            <th style={styles.thLog}>Arquivo</th>
                            <th style={styles.thLog}>Situação</th>
                            <th style={styles.thLogAcao}>Ação</th>
                        </tr>
                    </thead>

                    {loading ? (
                        <SkeletonTabela />
                    ) : (
                        <tbody>
                            {dados?.map((entry, index) => (
                                <tr key={entry.key || index} style={styles.trLog}>
                                    <td style={styles.tdLog}>
                                        {entry.usuarioCriacao?.nome}
                                    </td>

                                    <td style={styles.tdLog}>
                                        {formatarData(entry.dataHoraImportacao)}
                                    </td>

                                    <td style={styles.tdLog}>
                                        {entry.nomeArquivo}
                                    </td>

                                    <td style={styles.tdLog}>
                                        <BadgeSituacao situacao={entry.statusGlobal} />
                                    </td>

                                    <td style={styles.tdLogAcao}>
                                        <button
                                            onClick={() => onAcessarLog(entry.key)}
                                            disabled={STATUS_EM_ANDAMENTO.includes(entry.statusGlobal)}
                                            title={
                                                STATUS_EM_ANDAMENTO.includes(entry.statusGlobal)
                                                    ? "O arquivo ainda está na fila de processamento"
                                                    : "Baixar o LOG da importação"
                                            }
                                            style={{
                                                ...styles.linkImportar,
                                                color: STATUS_EM_ANDAMENTO.includes(entry.statusGlobal) ? '#bbb' : styles.linkImportar.color,
                                                cursor: STATUS_EM_ANDAMENTO.includes(entry.statusGlobal) ? 'not-allowed' : 'pointer',
                                            }}
                                        >
                                            Acessar LOG
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    )}
                </table>

                {!loading && dados?.length > 0 && (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "8px",
                            marginTop: "20px",
                            flexWrap: "wrap",
                        }}
                    >
                        <button
                            onClick={() => onIrParaPagina(paginaAtual - 1)}
                            disabled={paginaAtual === 1}
                            style={{
                                padding: "6px 12px",
                                border: "1px solid #ddd",
                                background: paginaAtual === 1 ? "#f5f5f5" : "#fff",
                                cursor: paginaAtual === 1 ? "not-allowed" : "pointer",
                                borderRadius: "4px",
                            }}
                        >
                            Anterior
                        </button>

                        {Array.from({ length: totalPaginas }, (_, index) => {
                            const pagina = index + 1;

                            return (
                                <button
                                    key={pagina}
                                    onClick={() => onIrParaPagina(pagina)}
                                    style={{
                                        padding: "6px 12px",
                                        border: "1px solid #ddd",
                                        background:
                                            paginaAtual === pagina ? "#007bff" : "#fff",
                                        color:
                                            paginaAtual === pagina ? "#fff" : "#333",
                                        cursor: "pointer",
                                        borderRadius: "4px",
                                        fontWeight: paginaAtual === pagina ? "600" : "400",
                                    }}
                                >
                                    {pagina}
                                </button>
                            );
                        })}

                        <button
                            onClick={() => onIrParaPagina(paginaAtual + 1)}
                            disabled={paginaAtual === totalPaginas}
                            style={{
                                padding: "6px 12px",
                                border: "1px solid #ddd",
                                background:
                                    paginaAtual === totalPaginas ? "#f5f5f5" : "#fff",
                                cursor:
                                    paginaAtual === totalPaginas ? "not-allowed" : "pointer",
                                borderRadius: "4px",
                            }}
                        >
                            Próxima
                        </button>
                    </div>
                )}

                {!loading && dados?.length === 0 && (
                    <div
                        style={{
                            padding: "40px 16px",
                            textAlign: "center",
                            color: "#999",
                            fontSize: "14px",
                        }}
                    >
                        Sem dados disponíveis
                    </div>
                )}
            </div>
        </>
    );
}

function GestaoDados() {
    const { Permissao, ExportarDados, ImportarDados, ListaLogConsulta,
        LogConsulta,
        totalRegistrosLog,
        ListaFiltroLog,
        filtroLog,
        totalRegistrosFiltroLog, loading, Success, Error, GerarLog, LogUsuario } = useContext(ApiContext);
    const { h3Demanda } = useContext(StyleContext);
    const [recurso, setRecurso] = useState("")
    const [paginaAtual, setPaginaAtual] = useState(1);
    const [textoFiltro, setTextoFiltro] = useState("");
    const [filtrando, setFiltrando] = useState(false);
    const [drawerAberto, setDrawerAberto] = useState(false);
    const [recursoSelecionado, setRecursoSelecionado] = useState(null);
    // logView: null = tela principal | { recurso, tipo } = tela de log
    const [logView, setLogView] = useState(null);
    const [importando, setImportando] = useState(false);
    const [exportando, setExportando] = useState(false);
    // contador usado para forçar o recarregamento do LOG
    const [logRefresh, setLogRefresh] = useState(0);

    useEffect(() => {
        setPaginaAtual(1);
        setFiltrando(false);
        setTextoFiltro("");
    }, [recurso]);
    useEffect(() => {
        const pulseStyle = document.createElement('style');
        pulseStyle.textContent = `
            @keyframes pulse-dot {
            0%   { transform: scale(1);   opacity: 1; }
            50%  { transform: scale(1.6); opacity: 0.45; }
            100% { transform: scale(1);   opacity: 1; }
            }
            `;
        if (!document.head.querySelector('[data-pulse-dot]')) {
            pulseStyle.setAttribute('data-pulse-dot', '1');
            document.head.appendChild(pulseStyle);
        }
    }, [])
    const dados = filtrando ? filtroLog : LogConsulta;
    const totalRegistros = filtrando ? totalRegistrosFiltroLog : totalRegistrosLog;
    const totalPaginas = Math.max(1, Math.ceil((totalRegistros || 1) / 20));
    const temPendentes = !!dados?.some((e) => STATUS_EM_ANDAMENTO.includes(e.statusGlobal));

    const handleBuscar = (texto) => {
        setTextoFiltro(texto);
        setPaginaAtual(1);
        setFiltrando(texto.trim().length > 0);
    };

    const handleLimparBusca = () => {
        setTextoFiltro("");
        setFiltrando(false);
        setPaginaAtual(1);
    };

    const irParaPagina = (pagina) => {
        if (pagina < 1 || pagina > totalPaginas) return;
        setPaginaAtual(pagina);
    };

    const handleAbrirDetalhes = (recursoObj) => {
        setRecursoSelecionado(recursoObj);
        setDrawerAberto(true);
    };

    const handleFecharDrawer = () => {
        setDrawerAberto(false);
    };

    const handleVoltarLog = () => {
        // Limpa todos os dados antes de voltar
        setPaginaAtual(1);
        setTextoFiltro("");
        setFiltrando(false);
        setRecurso("");
        setLogView(null);
    };

    const handleImportar = (recursoImportar) => {
        const input = document.createElement('input');
        input.type = 'file';
        // a API só aceita Excel (.xlsx/.xls)
        input.accept = '.xlsx,.xls';
        input.onchange = async (e) => {
            const arquivo = e.target.files[0];
            if (!arquivo) return;

            setImportando(true);
            try {
                const sucesso = await ImportarDados(recursoImportar, arquivo);

                if (sucesso) {
                    // abre o LOG do recurso já com o arquivo recém enfileirado
                    setPaginaAtual(1);
                    setTextoFiltro("");
                    setFiltrando(false);
                    setLogView({ recurso: recursoImportar, tipo: 'Importação' });
                    setRecurso(recursoImportar);
                    setLogRefresh((n) => n + 1);
                }
            } finally {
                setImportando(false);
            }
        };
        input.click();
    };

    const handleExportar = async (recurso) => {
        setExportando(true);
        try {
            await ExportarDados(recurso);
        } finally {
            setExportando(false);
        }
    };

    const handleSettings = (recurso, tipo = 'Importação') => {
        setLogView({ recurso, tipo });
        setRecurso(recurso)
    };

    useEffect(() => {
        if (!recurso) return;

        if (filtrando && textoFiltro.trim()) {
            ListaFiltroLog(
                textoFiltro,
                paginaAtual,
                20,
                recurso
            );
        } else {
            ListaLogConsulta(
                paginaAtual,
                20,
                recurso
            );
        }
    }, [
        recurso,
        paginaAtual,
        filtrando,
        textoFiltro,
        logRefresh,
        ListaFiltroLog,
        ListaLogConsulta,
    ]);

    // Enquanto houver arquivo na fila, recarrega o LOG em segundo plano
    // (sem loading) para o usuário ver a mudança de Pendente -> Concluído/Falha.
    useEffect(() => {
        if (!logView || !temPendentes) return;

        const intervalo = setInterval(() => {
            if (filtrando && textoFiltro.trim()) {
                ListaFiltroLog(textoFiltro, paginaAtual, 20, logView.recurso);
            } else {
                ListaLogConsulta(paginaAtual, 20, logView.recurso, true);
            }
        }, 8000);

        return () => clearInterval(intervalo);
    }, [
        logView,
        temPendentes,
        filtrando,
        textoFiltro,
        paginaAtual,
        ListaFiltroLog,
        ListaLogConsulta,
    ]);

    return (
        <div>
            <Header pagina={'Cadastros'} subpagina={'Gestão de Dados'} />
            <MenuLateral />

            {(importando || exportando) && <LoadingScreen />}

            {Success && (
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />
                    {Success}
                </div>
            )}
            {Error && (
                <div className='error'>
                    <IoIosWarning className='error-icon' />
                    {Error}
                </div>
            )}

            <div className='container-principal'>
                <div style={styles.containerPrincipal}>

                    {logView ? (
                        <TabelaLog
                            key={logView.recurso}
                            recurso={logView.recurso}
                            tipo={logView.tipo}
                            dados={dados}
                            loading={loading}
                            paginaAtual={paginaAtual}
                            totalPaginas={totalPaginas}
                            textoFiltro={textoFiltro}
                            temPendentes={temPendentes}
                            onVoltar={handleVoltarLog}
                            onBuscar={handleBuscar}
                            onLimpar={handleLimparBusca}
                            onAtualizar={() => setLogRefresh((n) => n + 1)}
                            onIrParaPagina={irParaPagina}
                            onAcessarLog={GerarLog}
                        />
                    ) : (
                        <>
                            <div style={styles.tituloBloco}>
                                <h3 style={{ color: h3Demanda, margin: 0 }}>
                                    Gestão de Dados - Importação/Exportação
                                </h3>
                            </div>

                            <div style={styles.tabelaWrapper}>
                                <table style={styles.tabela}>
                                    <thead style={styles.thead}>
                                        <tr>
                                            <th style={styles.thPortfolio}>Portfólio</th>
                                            <th style={styles.thRecurso}>Recurso</th>
                                            <th style={styles.thOperacao}>Operação</th>
                                            <th style={styles.thAcao}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {portfolioData.map((grupo) => (
                                            <React.Fragment key={grupo.portfolio}>
                                                <tr style={styles.trPortfolio}>
                                                    <td style={styles.tdPortfolioNome}>{grupo.portfolio}</td>
                                                    <td style={styles.tdVazio}></td>
                                                    <td style={styles.tdVazio}></td>
                                                    <td style={styles.tdVazio}></td>
                                                </tr>

                                                {grupo.recursos.map((recurso) => (
                                                    <tr key={recurso.nome} style={styles.trRecurso}>
                                                        <td style={styles.tdRecursoVazio}></td>
                                                        <td style={styles.tdRecursoNome}>{recurso.nome}</td>
                                                        <td style={styles.tdOperacao}>
                                                            {recurso.importar && (
                                                                <span
                                                                    style={styles.linkImportar}
                                                                    onClick={() => handleImportar(recurso.recurso)}
                                                                >
                                                                    Importar
                                                                </span>
                                                            )}
                                                            {recurso.importar && recurso.exportar && (
                                                                <span style={styles.separador}>|</span>
                                                            )}
                                                            {recurso.exportar && (
                                                                <span
                                                                    style={styles.linkExportar}
                                                                    onClick={() => handleExportar(recurso.recurso)}
                                                                >
                                                                    Exportar
                                                                </span>
                                                            )}
                                                        </td>
                                                        <td style={styles.tdAcao}>
                                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                                                                <span
                                                                    style={styles.iconSettings}
                                                                    onClick={() => handleAbrirDetalhes(recurso)}
                                                                    title="Ver detalhes do cadastro"
                                                                >
                                                                    <IoInformationCircleOutline />
                                                                </span>
                                                                <span
                                                                    style={styles.iconSettings}
                                                                    onClick={() => handleSettings(recurso.recurso)}
                                                                    title="Ver LOG do recurso"
                                                                >
                                                                    <IoSettingsOutline />
                                                                </span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </React.Fragment>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}
                </div>
            </div>
            <Drawer
                anchor="right"
                open={drawerAberto}
                onClose={handleFecharDrawer}
            >
                <div style={{ width: 360, padding: '24px', boxSizing: 'border-box' }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: '20px',
                        borderBottom: '1px solid #e0e0e0',
                        paddingBottom: '16px',
                    }}>
                        <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#333' }}>
                            Detalhes do Cadastro
                        </h3>
                        <span
                            style={{ cursor: 'pointer', color: '#999', display: 'flex' }}
                            onClick={handleFecharDrawer}
                        >
                            <IoIosClose size={24} />
                        </span>
                    </div>

                    {recursoSelecionado && (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            <div>
                                <div style={{ fontSize: '11px', color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '4px' }}>
                                    Nome
                                </div>
                                <div style={{ fontSize: '14px', color: '#333' }}>
                                    {recursoSelecionado.nome}
                                </div>
                            </div>

                            <div>
                                <div style={{ fontSize: '11px', color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '4px' }}>
                                    Recurso (chave)
                                </div>
                                <div style={{ fontSize: '14px', color: '#333' }}>
                                    {recursoSelecionado.recurso}
                                </div>
                            </div>
                            <div>
                                <div style={{ fontSize: '11px', color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '4px' }}>
                                    Operações para Importação de dados
                                </div>
                                <div style={{ fontSize: '14px', color: '#333' }}>
                                    Criar<br/>
                                    Atualizar<br/>
                                    Sem mudanças
                                </div>
                            </div>

                            {recursoSelecionado.recurso === "CapacidadeNegocioDemanda" &&
                                <div>
                                    <div style={{ fontSize: '11px', color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '4px' }}>
                                        Tipo da Capacidade
                                    </div>
                                    <div style={{ fontSize: '14px', color: '#333' }}>
                                       1 - Estratégica <br/>
                                       2 - Tática <br/>
                                       3 - Operacional
                                    </div>
                                </div>
                            }
                            {recursoSelecionado.recurso === "Sistema" &&
                                <div>
                                    <div style={{ fontSize: '11px', color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '4px' }}>
                                        Camada de Impacto no Negócio
                                    </div>
                                    <div style={{ fontSize: '14px', color: '#333' }}>
                                       Rodar<br/>
                                       Crescer<br/>
                                       Transformar
                                    </div>
                                </div>
                            }
                        </div>
                    )}
                </div>
            </Drawer>
            <Footer />
        </div>
    );
}

export default GestaoDados;
